module.exports = __webpack_public_path__ + "img/ifmPm.42fa19b3.svg";